const PATTERNS = [
  /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
  /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
];

/**
 * Extracts the 11-character video id from a YouTube URL (watch, youtu.be, embed
 * or shorts form). Returns null when the URL is empty or not recognised.
 */
export function extractYouTubeVideoId(url?: string | null): string | null {
  if (!url) {return null;}

  for (const pattern of PATTERNS) {
    const match = url.match(pattern);
    if (match) {return match[1];}
  }

  return null;
}
